module.exports = __webpack_public_path__ + "static/img/bg.71842cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/media5/bg.jpg
// module id = p55/
// module chunks = 7